import { defineStore } from 'pinia';
import { ref, shallowRef } from 'vue';

export const useModalStore = defineStore('modal', () => {
  const isVisible = ref(false);
  const title = ref<string | null>(null);
  const description = ref<string | null>(null);
  const noPadding = ref(false);
  const closeIcon = ref(false);
  const component = shallowRef<any>(null);
  const componentProps = ref<Record<string, any>>({});
  
function openModal(
  newTitle: string,
  newDescription: string,
  newComponent: any,
  props: object = {},
  noPaddingValue: boolean = false,
  whiteIconValue: boolean = false
) {
  title.value = newTitle;
  description.value = newDescription;
  component.value = newComponent;
  componentProps.value = props;
  noPadding.value = noPaddingValue;
  closeIcon.value = whiteIconValue;
  isVisible.value = true;
}
  
  function closeModal() {
    // console.groupCollapsed('[ModalStore] Closing Modal');
    // console.log('❌ Modal is being closed');
    // console.groupEnd();
    
    isVisible.value = false;
    title.value = '';
    description.value = '';
    component.value = null;
    componentProps.value = {};
  }
  
  return { isVisible, title, description, component, componentProps, noPadding, closeIcon, openModal, closeModal };
});
